import * as React from "react";
import styles from './index.module.css'
import { AddCircle, MinusCircle } from "../icons";

const Counter = ({value, onChange }) => {
  const [count, setCount] = React.useState(value);
  const handleDecrease = (e) => {
    e.stopPropagation();
    if (count > 0) {
      onChange(count - 1)
      setCount(val => val - 1);
    }
  };

  const handleIncrease = (e) => {
    e.stopPropagation();
    onChange(count + 1)
    setCount(val => val + 1);
  };

  return (
    <div className={styles.counter_btn_base}>
      <MinusCircle
        size={25}
        fill={"rgba(0, 0, 0, 0)"}
        className={styles.counter_btn_icon}
        onClick={handleDecrease}
      />
      <span>{count}</span>
      <AddCircle
        size={25}
        fill={"rgba(0, 0, 0, 0)"}
        className={styles.counter_btn_icon}
        onClick={handleIncrease}
      />
    </div>
  );
};

export default Counter;
